import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import Txt from '../../../../../Txt'
import Icon from '../../../../../Icons'
import Divider from '../../../../../Divider'
import useStyles from './useStyles'
import { getDateFormat, getArrayTimeFormat, getTimeFormat } from '../../../../../../tools/dataParse'
import { useTheme } from '../../../../../../theming/ThemeProvider'

const StopItem = (props) => {
  const {
    stop,
    stopNumber,
    isOrigin,
    isDestination
  } = props
  const { theme } = useTheme()
  const styles = useStyles(theme)

  return (
    <>
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          {isOrigin || isDestination
            ? (
              <Icon
                name={isOrigin ? 'Location' : 'Flag'}
                width={20}
                height={20}
                fill={theme.ICON_COLOR}
              />
            ) : (
              <View style={styles.stopsNumber}>
                <Txt
                  text={stopNumber}
                  identity='body3'
                  color='OUTER_SPACE'
                />
              </View>
            )}
        </View>
        <View style={styles.locationContainer}>
          <Txt
            text={`${stop?.city || '--'}, ${stop?.stateCode || '--'}`}
            identity='body2'
            color='OUTER_SPACE'
            selectable
          />
          <Txt
            text={`${stop?.zipCode} (Zip Code)`}
            identity='body3'
            color='OUTER_SPACE'
            selectable
          />
        </View>
        <View style={styles.timeContainer}>
          <Txt
            text={
              stop?.arrivals && stop?.arrivals.length
                ? getDateFormat(stop.arrivals[0]) || '- -'
                : '- -'
            }
            identity='body3'
            color='OUTER_SPACE'
            selectable
          />
          <Txt
            text={
              stop?.arrivals && stop?.arrivals.length
                ? stop.arrivals[1].date
                  ? getArrayTimeFormat(stop.arrivals)
                  : getTimeFormat(stop.arrivals[0])
                : '- -'
            }
            identity='body3'
            color='OUTER_SPACE'
            selectable
          />
        </View>
      </View>
      {!isOrigin && !isDestination ? (
        <Divider containerStyle={styles.divider} />
      ) : null}
    </>
  )
}

StopItem.propTypes = {
  stop: PropTypes.object,
  stopNumber: PropTypes.number,
  isOrigin: PropTypes.bool,
  isDestination: PropTypes.bool
}

export default StopItem
